import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ZefFormBase, ZefFormsModule } from '@vshosting/core';
import { PurgeCacheFormState } from './purge-cache-form.model';

@Component({
    selector: 'vshcdn-purge-cache-form',
    templateUrl: './purge-cache-form.component.html',
    styleUrls: ['./purge-cache-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatInputModule,
    MatFormFieldModule,
    ZefFormsModule
]
})
export class PurgeCacheFormComponent extends ZefFormBase<PurgeCacheFormState> {

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any;

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formErrorTranslations: any;

}
